import { render, staticRenderFns } from "./sizeset.vue?vue&type=template&id=13bdbd12"
import script from "./sizeset.vue?vue&type=script&lang=js"
export * from "./sizeset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13bdbd12')) {
      api.createRecord('13bdbd12', component.options)
    } else {
      api.reload('13bdbd12', component.options)
    }
    module.hot.accept("./sizeset.vue?vue&type=template&id=13bdbd12", function () {
      api.rerender('13bdbd12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pygame/components/sizeset.vue"
export default component.exports